import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  active_slide_index: null,
  new_slide_index: null,
  active_slide_name: null,
  active_slide_duration: 0,
  total_duration: 0,
  // slide_data: [],
  editingMode: false,
  single_slide_data: [],
  single_layer: {
    name: null,
    color: null,
    text: null,
    src: null,
    fontSize: null,
    fontFamily: null,
  },
  video_data: [],
  template_id: null,
  camp_id: null,
  editSlideData: [],
  is_loaded_img: false,
  gallery: [],
  delete_slides: {},
  editor_page_load: false,
  campaign_data: [],
  image_editor: null,
};

const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    resetState(state) {
      state.active_slide_index = null;
      state.active_slide_name = null;
      state.active_slide_duration = 0;
      state.total_duration = 0;
      state.editingMode = false;
      // state.slide_data = [];
      state.single_slide_data = {};
      state.video_data = [];
      state.template_id = [];
      state.camp_id = "";
      state.single_layer = {
        name: null,
        color: null,
        text: null,
        src: null,
        fontSize: null,
        fontFamily: null,
      };
      state.editSlideData = [];
      state.delete_slides = {};
      state.campaign_data = [];
    },
    preState(state, action) {
      state.camp_id = action.payload.camp_id;
    },
    addSlideData(state, action) {
      // state.slide_data = action.payload.slide_data;
    },
    doActiveSlide(state, action) {
      state.active_slide_index = action.payload.active_slide_index;
      state.active_slide_name = action.payload.active_slide_name;
      state.active_slide_duration = action.payload.active_slide_duration;
      state.single_slide_data = action.payload.single_slide_data;
    },
    setSingleSlideData(state, action) {
      if (action.payload.layer_name) {
        var copy_slide = { ...state.single_slide_data };
        var assets = copy_slide.assets;
        var newData = assets.map((slide_data) => {
          var a = { ...slide_data };

          // console.log(a);
          if (a.layerName === action.payload.layer_name) {
            a = { ...a, ...state.single_layer };
          }

          return a;
        });
        copy_slide.assets = newData;
        state.single_slide_data = copy_slide;
      } else {
        state.single_slide_data = action.payload.data;
      }
    },
    setVideoData(state, action) {
      state.video_data = action.payload.video_data;
    },
    setVideoDuration(state, action) {
      state.total_duration = action.payload.total_duration;
    },
    appendVideoData(state) {
      // console.log(state.video_data.slide_1);
      var previewData = [...state.video_data];

      previewData[state.active_slide_index] = state.single_slide_data;
      console.log(previewData);

      state.video_data = previewData;
    },
    editingMode(state) {
      state.editingMode = true;
    },
    setSingleLayerData(state, action) {
      // console.log("Hello");
      // console.log(action.payload.data);
      state.single_layer = action.payload.data;
    },
    clearSlideData(state) {
      state.editSlideData = [];
    },
    setSlideData(state, action) {
      // console.log(action.payload.data);
      state.editSlideData = action.payload.data;
    },
    setImageLoadedS3(state, action) {
      state.is_loaded_img = action.payload.is_loaded_img;
    },
    setGallery(state, action) {
      state.gallery = action.payload.gallery;
    },
    initDeleteSlide(state, action) {
      state.delete_slides = action.payload.delete_slides;
    },
    deleteSlide(state, action) {
      console.log("Delete");
      state.video_data = action.payload.previewData;
    },
    setEditorpageLoad(state, action) {
      state.editor_page_load = action.payload.editor_page_load;
    },
    changeIndex(state, action) {
      let new_arr = state.video_data;
      if (action.payload.newIndex >= new_arr.length) {
        var k = action.payload.newIndex - new_arr.length + 1;
        while (k--) {
          new_arr.push(undefined);
        }
      }
      new_arr.splice(
        action.payload.newIndex,
        0,
        new_arr.splice(action.payload.oldIndex, 1)[0]
      );

      state.video_data = new_arr;
      state.new_slide_index = action.payload.newIndex;
    },

    makeNullIndex(state, action) {
      state.new_slide_index = null;
    },
    setCampaignData(state, action) {
      state.campaign_data = action.payload.campaign_data;
    },
    setImageEditor(state, action) {
      state.image_editor = action.payload.content;
    },
    // makeSingleSlide(state, action) {
    //   state.single_layer = action.payload.single_layer_data;
    // },
  },
});

export const campaignAction = campaignSlice.actions;
export default campaignSlice.reducer;
